export enum paymentTypes {
  cod = "cod",
  invoice = "invoice",
}

export enum ActiveClickTypes {
  DECLINE = "decline",
  WITHDRAW = "withdraw",
  ACCEPT = "accept",
  ACCEPTQUOTE = "acceptQuote",
  APPROVE_ORDER = "approveOrder",
  REQUEST_DISCOUNT = "requestDiscount",
}
